export function EmptyState() {
  return (
      <div className="empty-state">
        <div className="empty-state-art">
          {/* Film camera SVG — gold strokes on void */}
          <svg
            className="empty-camera"
            width="120"
            height="100"
            viewBox="0 0 120 100"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {/* Camera body */}
            <rect x="20" y="35" width="80" height="50" rx="4" />

            {/* Lens barrel */}
            <circle cx="60" cy="60" r="16" />
            <circle cx="60" cy="60" r="10" opacity="0.6" />
            <circle cx="60" cy="60" r="4" opacity="0.3" />

            {/* Film reels on top */}
            <circle cx="40" cy="28" r="10" />
            <circle cx="40" cy="28" r="4" opacity="0.5" />
            <circle cx="72" cy="28" r="7" />
            <circle cx="72" cy="28" r="3" opacity="0.5" />

            {/* Film strip connecting reels */}
            <path d="M50 28 L65 28" opacity="0.4" />

            {/* Viewfinder */}
            <rect x="85" y="38" width="12" height="8" rx="1.5" opacity="0.6" />

            {/* Record indicator */}
            <circle cx="30" cy="42" r="2" fill="currentColor" opacity="0.4" />

            {/* Film gate lines */}
            <line x1="20" y1="75" x2="100" y2="75" opacity="0.2" />
          </svg>

          {/* Sparkle/star elements */}
          <svg className="sparkle sparkle-1" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path d="M6 0 L7 4.5 L12 6 L7 7.5 L6 12 L5 7.5 L0 6 L5 4.5 Z" />
          </svg>
          <svg className="sparkle sparkle-2" width="8" height="8" viewBox="0 0 12 12" fill="currentColor">
            <path d="M6 0 L7 4.5 L12 6 L7 7.5 L6 12 L5 7.5 L0 6 L5 4.5 Z" />
          </svg>
          <svg className="sparkle sparkle-3" width="10" height="10" viewBox="0 0 12 12" fill="currentColor">
            <path d="M6 0 L7 4.5 L12 6 L7 7.5 L6 12 L5 7.5 L0 6 L5 4.5 Z" />
          </svg>
          <svg className="sparkle sparkle-4" width="6" height="6" viewBox="0 0 12 12" fill="currentColor">
            <path d="M6 0 L7 4.5 L12 6 L7 7.5 L6 12 L5 7.5 L0 6 L5 4.5 Z" />
          </svg>

          {/* Lens flare glow */}
          <div className="lens-flare" />
        </div>

        <div className="empty-state-title">MUSE Studio</div>
        <div className="empty-state-hint">Start a creative session</div>

        <div className="suggestion-chips">
          <button className="suggestion-chip" tabIndex={-1}>Write something</button>
          <button className="suggestion-chip" tabIndex={-1}>Build a feature</button>
          <button className="suggestion-chip" tabIndex={-1}>Brainstorm ideas</button>
        </div>
      </div>
  );
}
